import React from 'react';
import PlayText, { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import { StyledErrorPage, ListHeading, List } from './ErrorPages.styles';
import { PlayLink } from '../../../../ui-components/PlayLink.styles';

const ErrorGeneral = ({ pathname }) => (
    <StyledErrorPage>
        <PlayText size={SIZE.LARGE}>Vi ber om ursäkt, men just nu går det inte att visa innehållet.</PlayText>
        <ListHeading as="h2">Det kan bero på:</ListHeading>
        <List>
            <li>Att du har tappat din uppkoppling mot internet.</li>
            <li>Att vi har tillfälliga tekniska problem.</li>
        </List>
        <ListHeading>Vad du kan göra:</ListHeading>
        <List>
            <li>Kontrollera att du är ansluten till internet.</li>
            <li>
                Testa att <PlayLink href={pathname}>ladda om sidan.</PlayLink>
            </li>
            <li>Återkom om en stund så är problemet förhoppningsvis löst.</li>
        </List>
    </StyledErrorPage>
);

export default ErrorGeneral;
